interface Props {
  children: React.ReactNode;
  className?: string;
}

/** Scrollable panel content wrapper. Uses Tailwind for layout. */
export default function PanelContent({ children, className = '' }: Props) {
  return (
    <div className={`flex flex-col h-full overflow-y-auto p-3 ${className}`.trim()}>{children}</div>
  );
}
